import React from 'react';
import './footer.css';
import { HiOutlineHome, HiOutlineUser, HiOutlineCalendar } from 'react-icons/hi';
import { Link } from 'react-router-dom'

const Footer = () => {
  return (

    <footer className="app-footer">

      <Link to="/establishment" className="footer-item active">
        <HiOutlineHome className="footer-icon" />
        <span>Home</span>
      </Link>

      <Link to="/services" className="footer-item">
        <HiOutlineCalendar className="footer-icon" />
        <span>Agendar</span>
      </Link>

      <Link to="/" className="footer-item">
        <HiOutlineUser className="footer-icon" />
        <span>User</span>
      </Link>

    </footer>

  )
}
export default Footer;